import { useMemo } from "react";
import { FORM_MODES } from "../config/authModalConfig/constants";
import {
  ValidateEmail,
  ValidateName,
  ValidatePassword,
  ValidatePhone,
  ValidateUsername,
} from "../utils/ValidateUtils";
import { ERROR_MESSAGES } from "../config/authModalConfig/constants";

export const useFormConfig = (modeForm, translations) => {
  const formConfig = useMemo(() => {
    const authTranslations = translations?.Authen || {};
    const placeholderTranslations = translations?.PlaceHolder || {};

    switch (modeForm) {
      case FORM_MODES.LOGIN:
        return {
          title: authTranslations.Login || "Login",
          submitText: authTranslations.Log_in || "LOG IN",
          fields: [
            {
              name: "email",
              label: authTranslations.Email || "Email",
              placeholder: placeholderTranslations.Email || "Enter email",
              type: "email",
              required: true,
              validator: ValidateEmail,
              errorMessage: ERROR_MESSAGES.INVALID_EMAIL,
            },
            {
              name: "password",
              label: authTranslations.Password || "Password",
              placeholder: placeholderTranslations.Password || "Enter password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
          ],
        };
      case FORM_MODES.REGISTER:
        return {
          title: authTranslations.Register || "Register",
          submitText: authTranslations.Sign_up || "Sign Up",
          fields: [
            {
              name: "username",
              label: authTranslations.Username || "Username",
              placeholder: placeholderTranslations.Username || "Enter username",
              type: "text",
              required: true,
              validator: ValidateUsername,
              errorMessage: ERROR_MESSAGES.INVALID_USERNAME,
            },
            {
              name: "email",
              label: authTranslations.Email || "Email",
              placeholder: placeholderTranslations.Email || "Enter email",
              type: "email",
              required: true,
              validator: ValidateEmail,
              errorMessage: ERROR_MESSAGES.INVALID_EMAIL,
            },
            {
              name: "phone",
              label: authTranslations.Phone || "Phone Number",
              placeholder: placeholderTranslations.Phone || "Enter phone number",
              type: "text",
              required: true,
              validator: ValidatePhone,
              errorMessage: ERROR_MESSAGES.INVALID_PHONE,
            },
            {
              name: "firstName",
              label: authTranslations.First_name || "First Name",
              placeholder: placeholderTranslations.First_name || "Enter first name",
              type: "text",
              required: true,
              validator: ValidateName,
              errorMessage: ERROR_MESSAGES.INVALID_NAME,
            },
            {
              name: "lastName",
              label: authTranslations.Last_name || "Last Name",
              placeholder: placeholderTranslations.Last_name || "Enter last name",
              type: "text",
              required: true,
              validator: ValidateName,
              errorMessage: ERROR_MESSAGES.INVALID_NAME,
            },
            {
              name: "password",
              label: authTranslations.Password || "Password",
              placeholder: placeholderTranslations.Password || "Enter password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
            {
              name: "RePassword",
              label: authTranslations.Confirm_password || "Confirm Password",
              placeholder: placeholderTranslations.Confirm_password || "Confirm password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
          ],
        };
      case FORM_MODES.FORGOT_PASSWORD:
        return {
          title: authTranslations.Forgot_your_password || "Forgot your password",
          submitText: authTranslations.Send || "Send",
          fields: [
            {
              name: "email",
              label: authTranslations.Email || "Email",
              placeholder: placeholderTranslations.Email || "Enter email",
              type: "email",
              required: true,
              validator: ValidateEmail,
              errorMessage: ERROR_MESSAGES.INVALID_EMAIL,
            },
          ],
        };
      case FORM_MODES.RESET_PASSWORD:
        return {
          title: "Reset Password",
          submitText: "Reset Password",
          fields: [
            {
              name: "password",
              label: authTranslations.Password || "Password",
              placeholder: placeholderTranslations.Password || "Enter new password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
            {
              name: "RePassword",
              label: authTranslations.Confirm_password || "Confirm Password",
              placeholder: placeholderTranslations.Confirm_password || "Confirm new password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
          ],
        };
      default:
        return {
          title: authTranslations.Login || "Login",
          submitText: authTranslations.Log_in || "LOG IN",
          fields: [
            {
              name: "email",
              label: authTranslations.Email || "Email",
              placeholder: placeholderTranslations.Email || "Enter email",
              type: "email",
              required: true,
              validator: ValidateEmail,
              errorMessage: ERROR_MESSAGES.INVALID_EMAIL,
            },
            {
              name: "password",
              label: authTranslations.Password || "Password",
              placeholder: placeholderTranslations.Password || "Enter password",
              type: "password",
              required: true,
              validator: ValidatePassword,
              errorMessage: ERROR_MESSAGES.INVALID_PASSWORD,
            },
          ],
        };
    }
  }, [modeForm, translations]);

  return formConfig;
};
